import axios from 'axios'

// Local, Dev Test, Production
export const AXIOS = axios.create({
        //baseURL: 'http://localhost:8080',
        baseURL: 'https://sales-pak.soft-pak.com',
        //baseURL: 'https://devtest.soft-pak.com',
        timeout: 10000
    }
)

export const COLORMAP = new Map([
    ["green", '#298a29'],
    ["gray", '#808080'],
    ["red", '#FF0000'],
    ["orange", '#FF8C00'],
    ["yellow", '#FFFF00'],
    ["teal", '#008080'],
    ["blue", '#0000FF'],
    ["indigo", '#4B0082'],
    ["purple", '#800080'],
    ["pink", '#FFC0CB'],
    ["black", '#000000']
]);

export const times = x => f => {
    if (x > 0) {
        f()
        times(x - 1)(f)
    }
};